import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "v-row titled-pane" }
const _hoisted_3 = { class: "v-column scroll-wrapper" }
const _hoisted_4 = ["data-index"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion v-column",
    ref: "el",
    style: _normalizeStyle({'--accordion-scroll-wrapper-height':`${_ctx.scrollWrapperHeight}px`})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (data, groupIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["list-view v-column", {expand: _ctx.expandedIndex === groupIndex}]),
        onClick: ($event: any) => (_ctx.onClick($event, data, groupIndex)),
        key: groupIndex
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(data.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", {selected: _ctx.selectedId === `${groupIndex}-${index}`}]),
              key: index,
              "data-index": index
            }, _toDisplayString(item.name), 11, _hoisted_4))
          }), 128))
        ])
      ], 10, _hoisted_1))
    }), 128))
  ], 4))
}